import axios from 'axios';
import { saveAs } from 'file-saver';
import { store } from '../redux/store';
import { selectCurrentToken } from '../redux/features/user/authSlice';

export const DownloadFiles = async (endpoint, filename, mimetype) => {
  const token = selectCurrentToken(store.getState());

  const getPdf = async () => {
    return axios.get(endpoint, {
      headers: {
        'Content-Type': 'multiple/form-data',
        ...(token && { authorization: `Bearer ${token}` }),
      },
      responseType: 'arraybuffer',
    });
  };

  const printPdf = async () => {
    const { data } = await getPdf();
    const blob = new Blob([data], { type: mimetype });
    saveAs(blob, filename);
  };

  printPdf();
};
